<template>
  <el-dialog
    v-if="!noTitle"
    :class="`modal-window ${modalWindowType}`"
    :title="$t(modalWindowName)"
    :width="window.width"
    :top="window.top"
    :visible="isVisible"
    :before-close="beforeCloseWindow"
    :close-on-click-modal="false"
  >
    <component v-bind:is="modalWindowName" />
  </el-dialog>
  <el-dialog
    v-else
    :class="`modal-window ${modalWindowType}`"
    :width="window.width"
    :top="window.top"
    :visible="isVisible"
    :before-close="beforeCloseWindow"
    :close-on-click-modal="false"
  >
    <component v-bind:is="modalWindowName" />
  </el-dialog>
</template>

<script>
import Account from "@/components/account/account";
import DsManager from "@/components/ds-manager/ds-manager.vue";
import About from "@/components/information/about";
import ModellingSettings from "@/components/modelling/components/modelling-settings";
import Profiles from "@/components/profiles/profiles-settings/profiles";
import SettingsReset from "@/components/settings/settings-reset";
import UserRoles from "@/components/user-roles/user-roles.vue";
import ChangeLog from "@/components/change-log/change-log";
import BookFilter from "@/components/book/book-filter/filter-settings";
import CreateObject from "@/components/create-object/create-object";
import DsExport from "@/components/ds-export/ds-export";
import UserTasks from "@/components/tasks/components/tasks-modal/tasks-modal";
import ScModalWindow from "@/components/situation-center/components/modules/modal-windows/basic-modal-window";

export default {
  components: {
    About,
    Account,
    DsManager,
    ModellingSettings,
    Profiles,
    SettingsReset,
    UserRoles,
    ChangeLog,
    BookFilter,
    CreateObject,
    DsExport,
    UserTasks,
    ScModalWindow
  },
  data() {
    return {
      modalWindowType: "default",
      noTitle: false,

      window: {
        width: "",
        top: ""
      }
    };
  },
  watch: {
    modalWindowName: {
      handler: function(val) {
        this.noTitle = false;
        if (val) {
          switch (val) {
            case "account":
            case "user-tasks":
              this.window.width = "max-content";
              this.window.top = "50px";
              this.modalWindowType = "account-window";
              break;
            case "settings-reset":
            case "modelling-settings":
              this.window.width = "400px";
              this.window.top = "20vh";
              this.modalWindowType = "small";
              break;
            case "book-filter":
            case "create-object":
              this.window.width = "400px";
              this.window.top = "20vh";
              this.modalWindowType = "min-height";
              break;
            case "ds-manager":
            case "about":
            case "profiles":
            case "change-log":
            case "ds-export":
            case "sc-modal-window":
              this.window.width = "max-content";
              this.window.top = "15vh";
              this.modalWindowType = "max-height";
              this.noTitle = true;
              break;
            default:
              this.window.width = "70%";
              this.window.top = "50px";
              this.modalWindowType = "default";
              break;
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    isVisible() {
      return this.$store.state.modalWindow.isShow;
    },
    modalWindowName() {
      return this.$store.state.modalWindow.name;
    },
    isActive() {
      return this.$store.state.modalWindow.isActive;
    }
  },
  methods: {
    beforeCloseWindow() {
      const title = this.$t("before:title");
      const message = this.$t("before-cancel:text");
      const confirmButtonText = this.$t("button-confirm");
      const cancelButtonText = this.$t("button-cancel");

      if (this.isActive) {
        this.$confirm(message, title, {
          customClass: "r-message-box",
          closeOnPressEscape: true,
          closeOnClickModal: false,
          type: "warning",
          confirmButtonText,
          cancelButtonText
        })
          .then(() => {
            this.closeWindow();
          })
          .catch(() => {});
      } else {
        this.closeWindow();
      }
    },
    closeWindow() {
      this.$store.commit("CLOSE_MODAL_WINDOW", "");
    }
  },
  mounted() {
    (function(states) {
      const modalWindow = document.querySelector(".modal-window");
      modalWindow.addEventListener("mousedown", function(e) {
        let closeWindow = false;

        if (e.target.classList) {
          e.target.classList.forEach(e => {
            if (e === "el-dialog__wrapper") {
              closeWindow = true;
            }
          });
        }
        if (closeWindow) states.beforeCloseWindow();
      });
    })(this);
  }
};
</script>

<style lang="scss">
.modal-window {
  .el-dialog {
    border-radius: var(--border-radius);
    // overflow: auto;
    position: relative;
    max-width: 1010px; // TODO: modify wit component library
    &__header {
      padding: 16px 16px 0;
    }

    &__headerbtn {
      top: 10px;
      right: 10px;
      z-index: 1000;
    }
    &__body {
      height: calc(100% - 88px);
      overflow: auto;
      padding: 16px !important;
      position: relative;
    }
  }
  &.default {
    .el-dialog {
      height: calc(90% - 50px);
      max-height: 1300px;
    }
  }
  &.small {
    .el-dialog {
      height: 250px;
      max-height: 500px;
    }
  }
  &.account-window {
    .el-dialog {
      height: calc(90% - 50px);
      max-height: 700px;
      &__header {
        text-align: center;
      }
    }
  }
  &.min-height {
    .el-dialog {
      max-height: 50vh;
    }
  }
  &.max-height {
    .el-dialog {
      max-height: 80vh;
      position: relative;
      min-width: 270px;
      min-height: 200px;
      overflow: hidden;
    }
  }
  .r-button {
    &.simple {
      color: var(--text_secondary) !important;
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "about": "Информация о системе",
    "account": "Данные пользователя",
    "ds-manager": "Менеджер источников данных",
    "modelling-settings": "Настройки моделирования",
    "profiles": "Настройки профилей",
    "settings-reset": "Сброс настроек профиля",
    "user-roles": "Роли и разрешения",
    "change-log": "Обновления",
    "book-filter": "Настройки фильтра",
    "create-object": "Создать новый объект",
    "ds-export": "Экспорт данных",
    "user-tasks": "Пользовательские задачи",

    "before:title": "Предупреждение",
    "before-cancel:text": "Все изменения будут отменены. Вы уверены?",
    "button-confirm": "Да",
    "button-cancel": "Отмена"
  },
  "en": {
    "about": "Information",
    "account": "Account",
    "ds-manager": "Datasource manager",
    "modelling-settings": "Modelling settings",
    "profiles": "Profiles settings",
    "settings-reset": "Reset profile settings",
    "user-roles": "Users & Roles",
    "change-log": "Updates",
    "book-filter": "Filter settings",
    "create-object": "Create new object",
    "ds-export": "Data export",
    "user-tasks": "User tasks",

    "before:title": "Warning",
    "before-cancel:text": "All changes will be discarded. Are you sure?",
    "button-confirm": "Yes",
    "button-cancel": "Cancel"
  }
}
</i18n>
